<template>
  <div class="row q-col-gutter-sm items-center">
    <model-form-toggle
      field="limitByQuantityEnabled"
      class="col-6"
      label="Limit By Quantity (e.g. Buy one get one)"
      :disable="conditional.isMeerkatMovieValue"
    />
    <q-select
      v-if="conditional.limitByQuantityEnabled"
      v-model="conditional.limitByQuantityType"
      class="col-6"
      label="Limit By Quantity Type"
      :options="LIMIT_BY_QUANTITY_TYPES.ALL"
      :option-label="(option) => $_.startCase(option)"
      emit-value
      :disable="conditional.isMeerkatMovieValue"
    >
      <template #option="{ itemProps, opt, toggleOption }">
        <q-item v-bind="itemProps">
          <q-item-section @click="toggleOption(opt)">
            <q-item-label>{{ opt.label }}</q-item-label>
            <q-item-label caption>
              {{ opt.tooltip }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
  <div class="row q-col-gutter-sm items-center">
    <model-form-select
      v-if="conditional.limitByQuantityEnabled && (conditional.type === 'ticket' || conditional.type === 'activity-ticket')"
      field="limitByQuantityFilter"
      class="col-4 q-mt-md"
      map-options
      :option-label="label => $_.startCase(label)"
      :options="LIMIT_BY_QUANTITY_FILTERS.ALL"
      label="Type Of Unique Items"
      :rules="[val => !!val || 'Field is required']"
      :disable="conditional.isMeerkatMovieValue"
    />
    <model-form-input
      v-if="conditional.limitByQuantityEnabled"
      field="numberOfMatchingItemsRequired"
      class="col-4 q-mt-md"
      :label="limitByQuantityLabel"
      type="number"
      step="1"
      :rules="[val => !!val || 'Field is required']"
      :disable="conditional.isMeerkatMovieValue"
    />
    <model-form-select
      v-if="conditional.limitByQuantityEnabled && conditional.limitByQuantityFilter === LIMIT_BY_QUANTITY_FILTERS.ACTIVITY_TICKET"
      field="limitByQuantityScope"
      class="col-4 q-mt-md"
      map-options
      :option-label="label => $_.startCase(label)"
      :options="LIMIT_BY_QUANTITY_SCOPES[conditional.limitByQuantityFilter]"
      label="That Share The Same"
      clearable
      :disable="conditional.isMeerkatMovieValue"
    />
  </div>
</template>

<script>
import { LIMIT_BY_QUANTITY_FILTERS, LIMIT_BY_QUANTITY_SCOPES, LIMIT_BY_QUANTITY_TYPES } from 'src/models/discount/Discount'

export default {
  name: 'LimitByQuantityForm',
  props: {
    conditional: {
      type: Object,
      required: true
    }
  },
  computed: {
    limitByQuantityLabel () {
      const type = this.conditional.type === 'ticket' || this.conditional.type === 'activity-ticket' ? this.conditional.limitByQuantityFilter : this.conditional.type
      return this.conditional.limitByQuantityType === LIMIT_BY_QUANTITY_TYPES.ALL_ITEMS.value ? `Minimum ${_.startCase(type)}s Required` : `${_.startCase(type)}s required per conditional`
    }
  },
  created () {
    _.extend(this, { LIMIT_BY_QUANTITY_TYPES, LIMIT_BY_QUANTITY_FILTERS, LIMIT_BY_QUANTITY_SCOPES })
  }
}
</script>
